import Icon from 'src/@core/components/icon'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import { useCallback, useState, useEffect } from 'react'
import { useDeviceScopedInit } from 'src/hooks/useDeviceScopedInit'

import { useTranslation } from 'src/utils/i18n'
import styles from '../../../styles/notes.module.scss'
import dayjs from 'dayjs'
import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'
import { getNotes } from 'src/@api/dashboard'
import Image from 'next/image'
import { setCurrentTab } from 'src/store/apps/Common'
import { useDispatch } from 'react-redux'
import ContentLoading from 'src/components/ContentLoading'

const Notes = () => {
  const { t } = useTranslation('common') // 使用翻译函数
  const [notesBoxes, setNotesBoxes] = useState(1) // 移动端显示层级
  const [initNotes, setInitNotes] = useState([]) // 初始笔记数据
  const [notes, setNotes] = useState([]) // 当前显示的笔记数据
  const [active, setActive] = useState(0) // 当前选中的笔记ID
  const [selectData, setSelectData] = useState({}) // 当前选中的笔记详细信息
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  const loadNotes = useCallback(async () => {
    setIsLoading(true)
    const response = await getNotes({
      username:
        JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : '',
      params: {
        category: 'NOTE',
        offset: 0,
        limit: 100
      }
    })
    setIsLoading(false)
    if (response.data.contents == null) {
      setInitNotes([])
      setNotes([])
      setSelectData({})
      return
    }

    const result = response.data.contents.map((item, index) => ({
      ...item,
      time: dayjs(item.created).format('YYYY/MM/DD HH:mm'),
      id: index
    }))

    setInitNotes(result)
    setNotes(result)
    setSelectData(result[0] || {})
  }, [])

  // 设备切换时重新拉数
  useDeviceScopedInit(loadNotes)

  // 处理当前搜索
  const handleFilter = e => {
    let value = e.target.value
    if (value === '') {
      setNotes(initNotes)

      return
    }

    // 搜索过滤
    let filterData = initNotes.filter(item => item.title.toLowerCase().includes(value.toLowerCase()))
    setNotes(filterData)
  }

  // 处理当前选中数据
  const handleSelectClick = id => {
    setNotesBoxes(2)
    setActive(id)
    let data = notes.find(item => item.id === id)
    setSelectData(data)
  }

  // 设置当前选项卡
  useEffect(() => {
    dispatch(setCurrentTab(t('Note')))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  if (isLoading) {
    return (
      <div
        className='relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-[calc(var(--vh2)*100-90px)] w-[100%] flex'
      >
        <ContentLoading />
      </div>
    )
  }

  return (
    <>
      <div
        className={`relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-[calc(var(--vh2)*100-90px)] w-[100%] hidden Hsm:flex flex-col`}
      >
        {notesBoxes === 1 ? (
          <>
            <div className='px-[15px]'>
              <TextField
                className='h-[40px] bg-[rgba(235,235,239,0.92)] rounded-lg !border-0 text-[16px] !mt-[15px]'
                fullWidth
                size='small'
                onInput={e => {
                  handleFilter(e)
                }}
                placeholder={t('Search Notes')}
                sx={{
                  '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': { border: 0 },
                  '& input::placeholder': { fontSize: '16px', color: '#818187', opacity: 100 }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                      <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                    </InputAdornment>
                  )
                }}
              />
            </div>

            <ul
              style={{ marginTop: '10px', overflow: 'auto', display: 'flex', flexDirection: 'column', width: '100%' }}
              className='px-[15px]'
            >
              {notes.map(row => (
                <li
                  key={row.id}
                  onClick={() => handleSelectClick(row.id)}
                  className='flex flex-col justify-center'
                  style={{
                    padding: '10px',
                    borderBottom: '1px solid #E4E4E6',
                    borderRadius: active == row.id ? '6px' : '2px',
                    cursor: 'pointer',
                    background: active == row.id ? '#FFE381' : ''
                  }}
                >
                  <div style={{ display: 'flex-1', display: 'flex' }}>
                    <span className={row.title.startsWith('http') ? 'break-all' : ''} style={{ fontWeight: '600', fontSize: '16px', lineHeight: '24px', color: '#000000' }}>
                      {row.title}
                    </span>
                  </div>

                  <div
                    style={{
                      display: 'flex-1',
                      color: '#808080',
                      fontSize: '14px',
                      fontWeight: '400',
                      color: 'rgba(0, 0, 0, 0.48)',
                      wordWrap: 'break-word',
                      lineHeight: '19.6px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: '1',
                      marginTop: '2px'
                    }}
                  >
                    <span
                      style={{
                        color: '#272727',
                        fontSize: '14px',
                        paddingRight: '3px',
                        lineHeight: '19.6px',
                        fontWeight: '400'
                      }}
                    >
                      {row.time}
                    </span>
                    &nbsp;
                    {row.text}
                  </div>
                </li>
              ))}
            </ul>
          </>
        ) : null}
        {notesBoxes === 2 ? (
          <>
            <div style={{ width: '100%', display: 'flex', color: '#000000', marginTop: '11px', padding: '10px' }}>
              <Icon icon='ion:chevron-back' onClick={() => setNotesBoxes(1)} />{' '}
              <span
                style={{ textAlign: 'center', fontSize: '18px', lineHeight: '27px', fontWeight: '600', margin: 'auto', wordBreak: selectData.title.startsWith('http') ? 'break-all' : 'unset' }}
              >
                {selectData.title}
              </span>
              <div className='w-[24px] h-[24px]'></div>
            </div>

            <div style={{ width: '100%', background: '#fff', overflow: 'auto' }}>
              <div
                style={{
                  margin: 'auto',
                  textAlign: 'center',
                  fontSize: '15px',
                  lineHeight: '22.5px',
                  fontWeight: '600',
                  margin: 'auto',
                  color: '#808080'
                }}
              >
                {selectData.time}
              </div>
              <div style={{ marginTop: '10px', padding: '0 16px' }}>
                <p style={{ fontSize: '16px', color: '#222222', lineHeight: '32px', wordBreak: selectData.text.startsWith('http') ? 'break-all' : 'unset' }}>{selectData.text}</p>
              </div>
            </div>
          </>
        ) : null}
      </div>

      <div
        className={`relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)] w-[100%] flex Hsm:hidden flex-row`}
      >
        {/* 左侧 */}
        <div className={styles.left} style={{ position: 'relative' }}>
          <div style={{ paddingTop: '10px', margin: '10px' }}>
            {/* 搜索过滤器 */}
            <TextField
              fullWidth
              size='small'
              onInput={e => {
                handleFilter(e)
              }}
              placeholder={t('Search Notes')}
              sx={{ '& .MuiInputBase-root': { borderRadius: 1 }, paddingLeft: '0px' }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    {/* <Icon icon='mdi:magnify' fontSize='1.25rem' /> */}
                    <Image src='/images/contacts/search.svg' width={18} height={18} alt='search'></Image>
                  </InputAdornment>
                )
              }}
            />
          </div>
          <div className={styles.list}>
            {/* 笔记列表 */}
            <ul className={styles.listUl}>
              {notes.map(row => (
                <li
                  key={row.id}
                  className={active == row.id ? styles.listLi : `${styles.listLi} ${styles.listLiSelected}`}
                  style={{ height: '80px', borderBottom: '1px solid #E5E7EB', borderRadius: '6px', display: 'flex-1' }}
                  onClick={() => handleSelectClick(row.id)}
                >
                  <h3 className={styles.listTitle}>{row.title}</h3>
                  <div className={styles.listDesc}>
                    <span className={styles.listTime}>{row.time}</span>
                    <p className={styles.listText}>{row.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          {(initNotes.length > 0 || isLoading) ||
            <div className='text-center px-2 absolute inset-0 z-[10] flex justify-center items-center pointer-events-none'>
              {t('It appears theres no data to show here yet')}<br />
              {t('If data exists it may take up to 1 hour to download and appear')}<br />
              {t('We suggest checking back in a little while')}
            </div>}
        </div>
        {/* 右侧 */}
        <div className='w-[90%] h-full flex flex-col m-auto items-center flex-1'>
          <span className='text-[15px] text-[#808080] pt-4 pb-[24px]'>{selectData?.time}</span>
          <span className='overflow-auto text-[16px] line-height-[24px] text-[#454545] w-full justify-center items-center text-center'>
            {selectData?.text}
          </span>
        </div>
      </div>

      {(initNotes.length > 0 || isLoading) ||
        <div className='text-center px-5 absolute inset-0 z-[10] flex justify-center items-center pointer-events-none smjs:hidden'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
    </>
  )
}

export default Notes

// 静态属性获取

